import { actions, helpers } from 'app-webtech-core';
import { changeChannelDirection } from 'app-modules/guide/actions';
import { showInfoBanner } from 'app-modules/player/actions';
import { DIRECTION } from 'app-modules/guide/constants/actions';
import { CHANNEL_DOWN } from './types';

const remoteControllerChannelDownButtonAction = helpers.actions.actionCreator(CHANNEL_DOWN);

export const remoteControllerChannelDownButtonThunkAction = () => async (dispatch) => {
  await dispatch(remoteControllerChannelDownButtonAction());

  await dispatch(changeChannelDirection(DIRECTION.UP));

  await dispatch(actions.guide.selectPreviousIndex({ updateInfo: true, autoPlay: true }));

  await dispatch(showInfoBanner());
};
